import { useCallback } from 'react';
import type { MedSection } from './types';

export const useEnsurePayloadMedSectionOrder = () => {
  const ensurePayloadMedSectionsOrder = useCallback(
    (sections: any): MedSection[] => {
      const list = Array.isArray(sections) ? sections : [];
      return list.map((section, sectionIndex) => ({
        ...section,
        order:
          Number.isFinite(Number(section?.order)) && Number(section?.order) > 0
            ? Number(section?.order)
            : sectionIndex + 1,
        medications: (Array.isArray(section?.medications)
          ? section.medications
          : []
        ).map((medication: any, medicationIndex: number) => ({
          ...medication,
          order:
            Number.isFinite(Number(medication?.order)) &&
            Number(medication?.order) > 0
              ? Number(medication?.order)
              : medicationIndex + 1,
        })),
      }));
    },
    [],
  );

  return {
    ensurePayloadMedSectionsOrder,
  };
};
